export const asszisztensNaptar = {
  title: "Asszisztens Naptár",
  chat: {
    title: "Naptár Asszisztens",
    placeholder: "Pl: 'Tegyél be egy találkozót pénteken 14:00-ra Annának'",
    welcomeMessage: "Szia! Segítek szerkeszteni a naptárat. Mondd meg mit szeretnél tenni!",
    examples: {
      title: "Példák:",
      addAppointment: "Tegyél be egy találkozót holnap 10-kor Péternek",
      moveAppointment: "Told el a keddi találkozót szerdára",
      deleteAppointment: "Töröld az Anna pénteki időpontját",
      checkAvailability: "Mikor ér rá Péter a jövő héten?"
    }
  },
  calendar: {
    title: "Csapat Naptár",
    weekView: "Heti nézet",
    todayButton: "Ma",
    previousWeek: "Előző hét",
    nextWeek: "Következő hét",
    noAppointments: "Nincs időpont erre a napra",
    teamMembers: "Csapattagok"
  },
  staff: {
    anna: "Anna",
    peter: "Péter",
    eva: "Éva",
    markus: "Márkó"
  },
  appointmentTypes: {
    meeting: "Találkozó",
    consultation: "Konzultáció",
    training: "Tréning",
    break: "Szünet",
    appointment: "Időpont"
  }
};